import * as React from 'react';
import OEITable from './OEITable';
import { ValidateEmail, doNothing } from './OEIUtils';
import { createUserAPI, fetchAllUserData, editUserdata, deleteUser } from './APIService';
import { useEffect } from 'react';
import { EMAIL_ID, EMPTY, FIELD_REQUIRED, FIRSTNAME, LASTNAME, LOADING, NO_USERS, USER, VALID_EMAIL } from './Constants';
export default function BasicTable() {
    const [users, setUsers] = React.useState([])
    const [generate, setGenerate] = React.useState('true');
    const [newUserData, setNewUserData] = React.useState();
    const [closePopover, setClosePopover] = React.useState(true);
    const [message, setMessage] = React.useState(LOADING);
    const [errors, setErrors] = React.useState({ error1: EMPTY, error2: EMPTY, error3: EMPTY });

    useEffect(function () {
        fetchTableData();
    }, [])
    const fetchTableData = () => {
        fetchAllUserData().then(response => {
            response.users.length === 0 ? setMessage(NO_USERS) : setMessage(EMPTY)
            setUsers(response.users);
        })
    };
    const columns = [
        { id: 'firstName', label: FIRSTNAME, align: 'left', edit: false, width: '30%', button: false },
        { id: 'lastName', label: LASTNAME, button: false, edit: false, width: '25%' },
        { id: 'email', label: EMAIL_ID, button: false, edit: false, width: '25%' },
        { id: 'Manage', label: EMPTY,buttonLabel:'Edit', button: true, edit: false, width: '10%' },
    ];
    const getUsers = () => {
        const newArr = users.map((element, index) => {
            return { ...element, userId: element?.id, id: element.email };
        });
        return newArr;
    }
    function validateData(data) {
        var errorList = [];

        if (data.lastName.trim() === EMPTY) {
            errorList = { ...errorList, error2: "Last Name is required" }
        } else if (data.lastName.length > 255) {
            errorList = { ...errorList, error2: 'Last Name length should be less than 255 characters' }
        }
        if (data.firstName.trim() === EMPTY) {
            errorList = { ...errorList, error1: "First Name is required" }
        } else if (data.firstName.length > 255) {
            errorList = { ...errorList, error1:'First Name length should be less than 255 characters'}
        } if (data.email.trim() === EMPTY) {
            errorList = { ...errorList, error3: 'Email is required' }
        } else if (ValidateEmail(data.email)) {
        } else {
            errorList = { ...errorList, error3: VALID_EMAIL }
        }
        setErrors({ ...errorList })
        return errorList.length === 0;
    }
    function handleClickGenerate() {
        setGenerate(false);
        const randomPassword =
            Math.random().toString(36).slice(2);

        setNewUserData({ ...newUserData, password: randomPassword });

    };
    function createUser() {
        if (validateData(newUserData)) {
            createUserAPI({ ...newUserData, password: Math.random().toString(36).slice(2) }).then(data => {
                if (JSON.stringify(data).includes('already exists')) {
                    setErrors({ ...errors,error3:"An User with the given email already exists."});
                    setGenerate(true);
                } else {
                    setClosePopover(true)
                    setGenerate(true);
                    fetchTableData();
                }
            }
            )
        }

    }

    const editUser = (row) => {
        if(validateData(row)){
            editUserdata(row).then(data  => {
                if (JSON.stringify(data).includes('already exists')) {
                    setErrors({ ...errors,error3:"An User with the given email already exists."});
                } else {
                    setClosePopover(true)
                    fetchTableData();
                }
            })
        }
    }
    const deleteUserData = (e) => {
        deleteUser(e?.userId).then(response => {
            setClosePopover(true)
            fetchTableData();
        })
    }
    return (
        <>
            <OEITable removeMainItem={doNothing}delete={deleteUserData} headerStyle='sticky-header' tableHeaderStyle='table-header' setSystemName={doNothing}
                edit={editUser} closePopover={closePopover} setClosePopover={setClosePopover} errors={errors} setErrors={setErrors}
                onclick={createUser} columns={columns}  setGenerate={setGenerate} generate={generate}
                handleManageAcct={doNothing} tableHeadings='Users' setEmail={doNothing}
                setNewData={setNewUserData} newAction={USER} handleClickGenerate={handleClickGenerate}
                newData={newUserData} rowData={getUsers()} message={message}></OEITable>
        </>
    );
}
